import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1807.11765,1807.05882 L621.235294,1807.05882 C590.031854,1807.05882 564.764706,1781.80913 564.764706,1750.58824 L564.764706,169.411765 C564.764706,138.190874 590.031854,112.941176 621.235294,112.941176 L1807.11765,112.941176 L1807.11765,0 L621.235294,0 C527.673624,0 451.823529,75.7977119 451.823529,169.411765 L451.823529,1750.58824 C451.823529,1844.20229 527.673624,1920 621.235294,1920 L1807.11765,1920 L1807.11765,1807.05882 Z",
  fillRule: "nonzero",
  transform: "matrix(-1 0 0 1 2258.941 0)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M225.941176 0L225.941176 1920 338.882353 1920 338.882353 0zM1219.02218 1016.47059L564.76001 1016.47059 564.76001 903.529412 1219.02218 903.529412 976.599976 661.107206 1056.46145 581.245735 1435.21571 960 1056.46145 1338.75427 976.599976 1258.89279z"
}));

var IconExpandStartLine = /*#__PURE__*/function (_Component) {
  _inherits(IconExpandStartLine, _Component);

  var _super = _createSuper(IconExpandStartLine);

  function IconExpandStartLine() {
    _classCallCheck(this, IconExpandStartLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconExpandStartLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconExpandStart",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconExpandStartLine.displayName = "IconExpandStartLine";
  return IconExpandStartLine;
}(Component);

IconExpandStartLine.glyphName = 'expand-start';
IconExpandStartLine.variant = 'Line';
IconExpandStartLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconExpandStartLine;
export { IconExpandStartLine };